#import '../fragments/widget-collapsed-fragment.graphql'

mutation UpdateWidgetCollapseState($input: WidgetUpdateCollapseStateInput!) {
    widgetUpdateCollapseState(input: $input) {
        widget {
            ...WidgetCollapsedFragment
        }
    }
}
